export default __webpack_public_path__ + "static/custom-watermark-e77404bd1ad327895b291499416b5b1a.jpg";